import styled from "styled-components";

export const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const FirstCardHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const FirstCardLeftColumn = styled.div`
  width: 70%;
  display: flex;
  align-items: center;
`;

export const FirstCardRightColumn = styled.div`
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const SecondCardContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
`;

export const SecondCardLeftColumn = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SecondCardRightColumn = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HighlightCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
`;

export const HighlightCardColumn = styled.div`
  flex: 1;
  display: flex;
`;

export const PermissionsCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const PermissionsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const PermissionsHeaderActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  & > button:last-child {
    padding: 4px 0px;
  }
`;

export const PermissionsContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PermissionItem = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
  padding-left: 16px;
  position: relative;

  &::before {
    content: "•";
    position: absolute;
    left: 0;
    top: 40%;
    transform: translateY(-50%);
    color: ${(props) => props.theme.colors.text};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

